<template>
  <v-container>
    <Title title="Reset Password"></Title>
    <v-row>
      <v-col md="12">
        <v-card class="mx-auto mt-12" max-width="550" :loading="isPasswordSubmitting">
          <v-card-text>
            <h2 class="text--primary py-5">Change Password</h2>
            <div class="text--primary">
              In order to
              <b>protect your account</b>, make sure your password:
              <div class="mb-5"></div>
              <ul>
                <li>Is alphanumeric</li>
                <li>Is longer than 7 characters</li>
                <li>Contains at least one special character</li>
              </ul>
            </div>
            <v-form ref="passwordForm" class="pt-5">
              <v-container>
                <v-row>
                  <v-col md="12" class="pt-0 px-0">
                    <v-text-field
                      label="New Password"
                      type="password"
                      v-model="password"
                      :rules="[passwordRules.required, passwordRules.min, passwordRules.alphanumeric, passwordRules.specialChar]"
                    ></v-text-field>
                  </v-col>
                  <v-col md="12" class="py-0 px-0">
                    <v-text-field
                      label="Re-enter New Password"
                      type="password"
                      v-model="confirmPassword"
                      :rules="[passwordRules.required, passwordRules.identicalRule]"
                    ></v-text-field>
                  </v-col>
                  <v-col ld="12" class="px-0">
                    <v-btn
                      color="primary"
                      tile
                      style="width:100%"
                      @click="onChangePassword()"
                    >Change password</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Title from "../components/Title";

export default {
  data() {
    return {
      password: "",
      confirmPassword: "",
      isPasswordSubmitting: false,
      passwordRules: {
        identicalRule: (v) =>
          v == this.password ||
          "Re-enter new password must be same as new password",
        required: (value) => !!value || "This field is required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
        alphanumeric: (v) =>
          /^[a-zA-Z0-9!@#$&()\\-`.+,/"]*$/.test(v) || "Alphanumeric only",
        specialChar: (v) =>
          /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(v) ||
          "At least 1 special character needed",
      },
    };
  },
  components: {
    Title,
  },
  methods: {
    onChangePassword: function () {
      if (!this.$refs.passwordForm.validate()) {
        return;
      }

      this.isPasswordSubmitting = true;

      const data = { password: this.password };

      fetch(
        `${process.env.VUE_APP_ROOT_API}/auth/password/reset?id=${this.$route.query.id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          body: JSON.stringify(data),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          this.isPasswordSubmitting = false;
          // this.$emit("passwordChanged", { message: data.message });
          this.$router.push({
            name: "Login",
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
</style>